import { render } from "./ManufacturerDashboardView.vue?vue&type=template&id=61899f84"
import script from "./ManufacturerDashboardView.vue?vue&type=script&lang=js"
export * from "./ManufacturerDashboardView.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/kinetics/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__